import { useEffect, useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroBanner from './components/HeroBanner';
import ServicesGrid from './components/ServicesGrid';
import BookingCTA from './components/BookingCTA';

const ServicesPage = () => {
  useEffect(() => {
    document.title = 'Our Services | Hair Cuts, Colouring & Styling | Riverdale Hair Studio Otley';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'Explore our full range of hair services in Otley including ladies and gents haircuts, professional colouring, special occasion styling, and premium hair treatments. Expert care for every client.');
    }
  }, []);

  const [activeCategory, setActiveCategory] = useState('Cutting');

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroBanner />
        <ServicesGrid activeCategory={activeCategory} setActiveCategory={setActiveCategory} />
        <BookingCTA />
      </main>
      <Footer />
    </div>
  );
};

export default ServicesPage;